<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Estatus</label>
                </div>

                <div class="col-auto">
                    <select @change="Lista" v-model="Estatus" class="form-select form-control-search">
                        <option value="3">Pendientes</option>
                        <option value="4">Facturadas</option>
                        <option value="5">Terminadas</option>
                    </select>
                </div>
            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Empresa</th>
                <th :class="StyleTh">Total</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><p :class="StyleTd">{{lista.cliente.Nombres}}</p></td>
                    <td><p :class="StyleTd" v-if="lista.Agente.NombreComercial">{{lista.Agente.NombreComercial}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.TotalGlobal}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdCotizacion" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <CMoreButtonsL>
							        <template slot="bodyBtnsL">
                                        <template v-if="lista.Estatus<5">
                                        <template v-if="segurity.ViewInvoice">
                                            <li @click="IrAlDetalle(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-list"></i> Ver Facturas
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.ViewSalesNote">
                                            <li @click="IrANotasDeVenta(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-list"></i> Ver Notas de venta
                                                </a>
                                            </li>
                                        </template>
                                        </template>
                                        <template v-if="segurity.AuthorizeInvoice">
                                            
                                            <li v-if="lista.Estatus<4" @click="AutorizarCotizacion(lista,4)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-check"></i> Autorizar Facturado
                                                </a>
                                            </li>
                                            
                                        </template>
                                            <li v-if="lista.Estatus == 4" @click="AutorizarCotizacion(lista,3)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-undo"></i> Revertir Autorización
                                                </a>
                                            </li>
                                            <li v-if="lista.Estatus == 5" @click="AutorizarCotizacion(lista,4)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-undo"></i> Revertir Autorización
                                                </a>
                                            </li>
                                            <li v-if="lista.Estatus>3 && lista.Estatus<5" @click="AutorizarCotizacion(lista,5)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-check"></i> Finalizar Facturación
                                                </a>
                                            </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
			</template>
		</CList>
	</div>
</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCotizacion';

export default {
    name: 'ListaCotizacion',
    props: ['sFiltros','pOrigen','pLugar'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Cotizaciones Pendientes',
                IsModal: true,
                ShowYear: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                BtnNewShow: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Anio: moment(new Date()).format('YYYY'),
            },
            Lugar:'',
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Estatus: 3,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            let user = JSON.parse(sessionStorage.getItem('user'));
            let IdEmpresa = user.IdEmpresa;
            let IdSucursal = user.IdSucursal;
            await this.$http.get("cotzPendientes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Estatus: this.Estatus,
                    Tipo:this.Lugar,
                    IdEmpresa: IdEmpresa,
                    IdSucursal: IdSucursal,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IrAlDetalle(item){
            this.$router.push({name: 'factura',params:{pObjEnviado: item, pLugar: 'CotzxFactura'}});
        },
        IrANotasDeVenta(item){
            this.$router.push({name: 'notaventa',params:{pObjEnviado: item, pLugar: 'CotzxNota'}});
        },
        AutorizarCotizacion(item,Estatus)
        {
            let message = '';
            if(Estatus == 3)
            {
                message = '¿Desea Revertir La Autorización?';
            }
            else if(Estatus == 4){
                message = '¿Desea Confirmar Facturado?';
            }
            else if(Estatus == 5){
                message = '¿Desea Finalizar El Proceso de Facturación?';
            }

            this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">'+message+'</h2>',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result) =>
            {
                if(result.value)
                {
                    this.$http.get('cotzConfirmarFactura',{
                        params:{
                            IdCotizacion: item.IdCotizacion,
                            Estatus: Estatus,
                        }
                    }).then((res) => {
                        this.$swal('Cotización Facturada','','success');
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        }
    },
    created()
    {
        if(this.pLugar != undefined){
            sessionStorage.setItem('Lugar',JSON.stringify(this.pLugar));
        }
        if(this.pLugar === ''){
            sessionStorage.removeItem('Lugar');
        }
        console.log(this.pLugar)
        this.Lugar = JSON.parse(sessionStorage.getItem('Lugar'));

        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
